var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestinationimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "weui:location-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50799 14.756C7.50799 14.756 2.66666 10.6787 2.66666 6.66671C2.66666 5.25222 3.22856 3.89567 4.22875 2.89547C5.22895 1.89528 6.5855 1.33337 7.99999 1.33337C9.41448 1.33337 10.771 1.89528 11.7712 2.89547C12.7714 3.89567 13.3333 5.25222 13.3333 6.66671C13.3333 10.6787 8.49199 14.756 8.49199 14.756C8.22266 15.004 7.77932 15.0014 7.50799 14.756ZM7.99999 9.00004C8.30641 9.00004 8.60982 8.93969 8.89292 8.82243C9.17601 8.70517 9.43324 8.53329 9.64991 8.31662C9.86658 8.09995 10.0384 7.84273 10.1557 7.55964C10.273 7.27654 10.3333 6.97313 10.3333 6.66671C10.3333 6.36029 10.273 6.05687 10.1557 5.77378C10.0384 5.49069 9.86658 5.23346 9.64991 5.01679C9.43324 4.80012 9.17601 4.62825 8.89292 4.51099C8.60982 4.39373 8.30641 4.33337 7.99999 4.33337C7.38115 4.33337 6.78766 4.57921 6.35007 5.01679C5.91249 5.45438 5.66666 6.04787 5.66666 6.66671C5.66666 7.28555 5.91249 7.87904 6.35007 8.31662C6.78766 8.75421 7.38115 9.00004 7.99999 9.00004Z",
    fill: "#2C358A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationimg);
export default __webpack_public_path__ + "static/media/destinationimg.b669322858aeebe6ad120a4d9b18f8ed.svg";
export { ForwardRef as ReactComponent };